<div class="z-page-loader" [class.--show]="showLoading">
  <span class="z-loader-html w-48 mb-2"></span>
  <p style="user-select: none">{{ textLoading$ | async }}</p>
</div>